import {
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
} from '@com/utils/storage'
import Cookies from 'js-cookie'
import isMaterialWarehouse, { isAssetsFactory } from '@/common/is-warehouse'

export const language = {
  set(val) {
    setLocalStorage('language', val)
  },
  get(options) {
    // 兜底语言（en） 如果设置为ja等新语言，使用en作为兜底语言
    const language =
      getLocalStorage('language') || navigator.language.toLowerCase()

    // 直接返回local storage的语言
    if (options && options.reality) {
      return language
    }

    return ['ja'].indexOf(language) !== -1 ? 'en' : language
  },
  remove() {
    removeLocalStorage('language')
  },
}

// LocalStorage内language值
export const localLanguage = {
  get() {
    return getLocalStorage('language') || navigator.language.toLowerCase()
  },
}

const tokenKey = 'token'
const cookieTokenKey =
  isMaterialWarehouse() || isAssetsFactory() ? 'auth' : 'mws_auth'
export const token = {
  set(val) {
    Cookies.set(cookieTokenKey, val)
    setLocalStorage(tokenKey, val)
  },
  get() {
    return (
      // 兼容cookie中带有pt_auth的情况
      getLocalStorage(tokenKey) ||
      Cookies.get(cookieTokenKey) ||
      Cookies.get('pt_auth')
    )
  },
  remove() {
    Cookies.remove(cookieTokenKey)
    // 兼容cookie中带有pt_auth的情况
    Cookies.remove('pt_auth')
    removeLocalStorage(tokenKey)
  },
}
